const { createMemoryStore } = require('../../../utilities/createStore');

module.exports = createMemoryStore();
